import { cartDetailsFragment } from '../queries/get-cart-query'

const cartLineItemAdd = `
  mutation cartLinesAdd(
    $cartId: ID!
    $lineItems: [CartLineInput!]!
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartLinesAdd(cartId: $cartId, lines: $lineItems) {
      userErrors {
        code
        field
        message
      }
      cart {
        ...cartDetails
      }
    }
  }

  ${cartDetailsFragment}
`

export default cartLineItemAdd
